import { DefaultSidebar, Sidebar, THEME } from "@excalidraw/excalidraw";
import {
  messageCircleIcon,
  presentationIcon,
} from "@excalidraw/excalidraw/components/icons";
import { GlobalComments } from "./GlobalComments";
import { useUIAppState } from "@excalidraw/excalidraw/context/ui-appState";
import { useExcalidrawAPI } from "@excalidraw/excalidraw/components/App";

import "./AppSidebar.scss";
import "./PresentationMode.scss";

export const AppSidebar = () => {
  const { theme, openSidebar, viewModeEnabled, zenModeEnabled } =
    useUIAppState();
  const excalidrawAPI = useExcalidrawAPI();

  const toggleViewMode = () => {
    excalidrawAPI?.updateScene({
      appState: { viewModeEnabled: !viewModeEnabled },
    });
  };

  const toggleZenMode = () => {
    excalidrawAPI?.updateScene({
      appState: { zenModeEnabled: !zenModeEnabled },
    });
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <DefaultSidebar>
      <DefaultSidebar.TabTriggers>
        <Sidebar.TabTrigger
          tab="comments"
          style={{ opacity: openSidebar?.tab === "comments" ? 1 : 0.4 }}
        >
          {messageCircleIcon}
        </Sidebar.TabTrigger>
        <Sidebar.TabTrigger
          tab="presentation"
          style={{ opacity: openSidebar?.tab === "presentation" ? 1 : 0.4 }}
        >
          {presentationIcon}
        </Sidebar.TabTrigger>
      </DefaultSidebar.TabTriggers>
      <Sidebar.Tab tab="comments">
        <GlobalComments />
      </Sidebar.Tab>
      <Sidebar.Tab tab="presentation" className="px-3">
        <div className="presentation-mode-container">
          <div className="presentation-mode-icon">🖥️</div>
          <h3 className="presentation-mode-title">Presentation Mode</h3>
          <p className="presentation-mode-desc">
            Present your drawings in fullscreen with a clean, distraction-free
            view.
          </p>
          <div className="presentation-mode-buttons">
            <button
              className={`presentation-btn ${
                viewModeEnabled
                  ? "presentation-btn-active"
                  : "presentation-btn-primary"
              }`}
              onClick={toggleViewMode}
            >
              {viewModeEnabled
                ? "✅ Exit View Mode"
                : "🎬 Start Presentation (View Mode)"}
            </button>
            <button
              className={`presentation-btn ${
                zenModeEnabled
                  ? "presentation-btn-active"
                  : "presentation-btn-secondary"
              }`}
              onClick={toggleZenMode}
            >
              {zenModeEnabled
                ? "✅ Exit Zen Mode"
                : "🧘 Zen Mode (Hide Toolbar)"}
            </button>
            <button
              className="presentation-btn presentation-btn-fullscreen"
              onClick={toggleFullscreen}
            >
              ⛶ Toggle Fullscreen
            </button>
          </div>
          <div className="presentation-mode-tips">
            <p className="tips-title">⌨️ Keyboard Shortcuts</p>
            <ul>
              <li>
                <kbd>Alt</kbd>+<kbd>R</kbd> — View Mode
              </li>
              <li>
                <kbd>Alt</kbd>+<kbd>Z</kbd> — Zen Mode
              </li>
              <li>
                <kbd>F11</kbd> — Fullscreen
              </li>
              <li>
                <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>H</kbd> — Fit screen
              </li>
              <li>
                <kbd>Esc</kbd> — Exit mode
              </li>
            </ul>
          </div>
        </div>
      </Sidebar.Tab>
    </DefaultSidebar>
  );
};
